const endpoints = {
    qa: {
        baseUrl: 'https://test.api.hda.web-magic.space',
        baseAdminUrl: 'https://test.nebula.hda.web-magic.space',
    },
    prod: {
        baseUrl: 'https://api.bodylytix.ai',
        baseAdminUrl: 'https://dashboard.bodylytix.ai',
    },
    dev: {
        baseUrl: 'http://localhost',
        baseAdminUrl: 'http://localhost',
    },
};

export default endpoints;